import React from "react";

  function MyCard({ className = "", children ,onClick}) {
  return (
    <div
    onClick={() => onClick && onClick()}
      className={`w-full   ${className} rounded-xl backdrop-blur-sm bg-white dark:bg-slate-300/20 border border-input border-gray-300/60 dark:border-gray-400/30`}
    >
      {children}
    </div>
  );
}
export default MyCard;
